import { LogoLockup } from "./UMark";
import { site } from "@/site.config";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-navy py-10">
      <div className="mx-auto flex w-full max-w-[1200px] flex-col items-center justify-between gap-6 px-6 text-center md:flex-row md:text-left">
        <p className="text-sm text-white/60">
          © {new Date().getFullYear()} {site.name}
        </p>
        <LogoLockup on="navy" markSize={26} className="[&>span:last-child]:text-base" />
      </div>
    </footer>
  );
}
